export default __webpack_public_path__ + "static/media/A100.f9749df6.png";